// ie: Engine.ui.misc();
$(function() {
  "use strict";
  var Engine = {
    ui: {
      misc: function() {
        $("button.navbar-expand-toggle,.close_arrow").on('click', function() {
          $('body').toggleClass("nav_open");
          return false;
        });
        
        $('body').click(function(e){
          var container = $(".app-sidemenu");
          // if the target of the click isn't the container nor a descendant of the container
          if (!container.is(e.target) && container.has(e.target).length === 0) 
          {
             $('body').removeClass("nav_open");
          }
        });
        
        $(".shoppingcart_btn,.cart-close").on('click', function() {
          $("body").toggleClass("CartOpen");
          return false;
        });
//         
//         $(document).on('click', '.CartOpen .main-content', function(){        
//           $('body').removeClass('CartOpen');    
//         });
//         
        $(".btn-search,.btn-close-search").on('click', function() {
          $(".primary_wrap").toggleClass("opensearch");
          return false;
        });
        $('.shop_item .shop_desc h5, .services-block, .blog_item .blog_content').matchHeight({
          property: 'height'
        });
        $('.QuantityBox .plus').on('click', function() {            
          var $qty = $(this).parents('.QuantityBox').find(".QuantityInput");
          var currentVal = parseInt($qty.val(), 10);
          if (1 <= currentVal) {
            $(this).parents('.QuantityBox').find('li.minus-box').removeClass('disabled');
          }
          if (!isNaN(currentVal)) { $qty.val(currentVal + 1);}
        });
        $('.QuantityBox .minus').on('click', function() {
          var $qty = $(this).parents('.QuantityBox').find(".QuantityInput");
          var currentVal = parseInt($qty.val(), 10);
          if (currentVal <= 2) {
            $(this).parents('.QuantityBox').find('li.minus-box').addClass('disabled');
          }
          
          if (!isNaN(currentVal) && currentVal > 1) {$qty.val(currentVal - 1);}
        });
        $('.quotes-slider__text .rte-setting').matchHeight({property: 'height'});
        $('.collapsible-trigger').on('click', function() {
          if($(this).parent('li.filter_items').hasClass("is-open")){
            $(this).parent('li.filter_items').removeClass("is-open"); 
            $(this).parent('li.filter_items').find('ul.filter_group').slideUp(500);
          }
          else{            
            $(this).parent('li.filter_items').addClass("is-open");  
            $(this).parent('li.filter_items').find('ul.filter_group').slideDown(500);
          }
        });
        $('.cal_anchor').on('click', function() {
          $('#shipping-calculator').slideToggle();
          return false;
        });
        $(document).on('click', '.wc_product_review_badge', function() {           
          $('a[href="#shop_reviews"]').trigger( "click" );
          $('html, body').animate({
            scrollTop: $("#theme_tabs").offset().top - 50
          }, 1500);
        });
      }, // end misc
      metisNavMenu: function() {
        $("#mobile_nav").metisMenu({
          toggle: true,
          triggerElement: 'li',
        });                
        $('.fillter_nav_list').metisMenu({
          toggle: true,
          triggerElement: '.has-arrow',
          parentTrigger: '.nav_sublist',
          subMenu: '.submenu'
        });
        $("#FAQs_Content").metisMenu();

        if ($(window).width() <= 767) {					
          $("#footer_link_list").metisMenu();         
        }
      }, // end metisMenu
//       stickyHeader: function() { 
//        var HHeight = $('header').innerHeight();
//         alert(HHeight);
//         $(window).scroll(function() {         
//           if ($(this).scrollTop() >= HHeight) {
//             $('.stickywrap').addClass('stickyHeader');            
//           } else {
//             $('.stickywrap').removeClass('stickyHeader');   
//           }
//         });
//       },
    }, // end ui
    utils: {
      sliders: function() {
        //  Home Slider
        $('.heroslider').slick({
          arrows: true,
          speed: 1000,
          dots: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
          touchMove: true,
          slide: 'li',
          responsive: [
            {
              breakpoint: 992,
              settings: {
                arrows: false,
                dots: true
              }
            }
          ]
        });     
      },
    }, // end utils
  };
  Engine.ui.misc();
  Engine.ui.metisNavMenu();
  if($('.wc_site_main_header').data('stickey') == true){
    Engine.ui.stickyHeader();
  }
  Engine.utils.sliders();
});

$(document).ready(function(e) {
var $filterSidebar = $('#sidebar-widgets-filters');
  var $toggleButton = $('.wc_filter_toggle');
  var $overlay = $('body').find('.widgets-filter-overlay');
  function _open() {
    $filterSidebar.addClass('open');
    if (! $overlay.length) {
      $('body').append('<div class="widgets-filter-overlay"></div>');
    }
    $('body').addClass('open-filters-open');
  }
  function _close() {
    $filterSidebar.removeClass('open');
    $(document).find('.widgets-filter-overlay').remove();
    $('body').removeClass('open-filters-open');
  }
  $toggleButton.on('click', function() {
    if (! $filterSidebar.hasClass('open')) {
      _open();
    } else {
      _close();
    }
  });
  $('body').on('click', '.widgets-filter-overlay', function() {
    _close();
  });
  
});
